module.exports = __webpack_public_path__ + "TB_Powerup_SFX_A.wav.437aca31.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_up/TB_Powerup_SFX_A.wav.mp3
// module id = 506
// module chunks = 0